const mNotFound = {
  mNotFound: {
    link: 'Volver a la página de inicio',

    title: {
      first: 'Oops!',
      second: 'La página que estás buscando no está aquí.'
    }
  }
}

export default mNotFound
